import config from './config'

export default {
  name: 'wbap-admin-main',
  version: '1.0.0',
  description: '项目骨架',
  config: config,
  components: [],
  load: (cb) => {
    cb(require('./page').default, require('./model').default)
  }
}


// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-main/index.js